import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ── Auto Test Mode — bypass entire app (including login) when URL has ?autotest=1 ──
const AutoTestPage = lazy(() => import('./pages/AutoTestPage'));

function AutoTestFallback() {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif',
      fontSize: 14, color: '#1e293b',
    }}>
      Loading Auto Test Runner...
    </div>
  );
}

// Only reachable in local development builds — never mounts in production,
// so ?autotest=1 cannot bypass login or write test data on the live site.
const isAutoTest = process.env.NODE_ENV !== 'production' &&
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('autotest') === '1';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isAutoTest ? (
      <Suspense fallback={<AutoTestFallback />}>
        <AutoTestPage />
      </Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// Register service worker for offline-first caching and faster repeat loads
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
